import { AddressFormData, EditAddressFormData } from '../../entities/Address/Address'
import { patchAddressApiCall, postAddressApiCall } from '../../entities/Address/AddressService'
import { isFetchResultSuccessful } from '../../entities/FetchResult'
import { NotificationCenterLog } from '../../entities/NotificationCenter/NotificationCenter'

export const addAddress = async (addressFormData: AddressFormData, personId: string, eventLogTrackerData?: NotificationCenterLog): Promise<void> => {
    const response = await postAddressApiCall(addressFormData, personId, eventLogTrackerData)

    if (! isFetchResultSuccessful(response)) {
        throw new Error('addAddress')
    }
}

export const editAddress = async (addressFormData: EditAddressFormData, personId: string, eventLogTrackerData?: NotificationCenterLog): Promise<void> => {
    const response = await patchAddressApiCall(addressFormData, personId, eventLogTrackerData)

    if (! isFetchResultSuccessful(response)) {
        throw new Error('editAddress')
    }
}
